import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import "./assets/styles/element-variables.scss";
// import "@/assets/css/common.scss";
// import BaiduMap from "vue-baidu-map";
import axios from "axios";

import "./vant"; // @H5.vant
import "./styles/reset.css";

import "./utils/rem.js";
import htmlToPdf from "@/utils/htmlToPdf";
import Print from "@/utils/print";
// import "amfe-flexible";
import preventReClick from "@/utils/util";

import tip from "./common/loadingjs.js";
Vue.prototype.$tip = tip; // 在这里挂载到全局
// Vue.use(tip);

Vue.use(preventReClick);

import { Cascader } from "vant";
Vue.use(Cascader);

import { Badge } from "vant";
Vue.use(Badge);

Vue.use(Print);
Vue.use(htmlToPdf);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$filePath = process.env.VUE_APP_FILE_URL;
Vue.use(ElementUI);
// Vue.use(BaiduMap, {
//   ak: "5iZVU2TpODpAD3ocXkwmgGS8mNDcqW0U",
// });
// Vue.use($)

// 正式环境清除所有console.log
if (process.env.NODE_ENV === "production") {
  if (window) {
    window.console.log = function () {};
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
